import React, { Component } from "react";
import { Layout, Row, Col } from "antd";
import { Route, Switch } from "react-router-dom";

import authRoute from "../HOCs/AuthRoute";
import Navbar from "../Components/Navigation/Navbar";
import ComponentFooter from "../Components/Footer/ComponentFooter";

import Orders from "./Orders";
import OrderDetail from "./OrderDetail";
import LastOrder from "./LastOrder";
import Profile from "./Profile";

const { Content } = Layout;

class Dashboard extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }
  render() {
    return (
      <Layout style={{ overflow: "hidden" }}>
        <Navbar />
        <Content
          style={{
            background: "#fff",
            minHeight: "95vh",
            marginTop: "64px"
          }}
        >
          <Row type="flex" justify="center" align="middle" style={{ flex: 1 }}>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 24 }}
              lg={{ span: 24 }}
              xl={{ span: 22 }}
              xxl={{ span: 18 }}
            >
              <Switch>
                <Route exact path="/" component={LastOrder} />
                <Route path="/profile" component={Profile} />
                <Route exact path="/orders" component={Orders} />
                <Route path="/orders/:orderId" component={OrderDetail} />
              </Switch>
            </Col>
          </Row>
        </Content>
        <ComponentFooter />
      </Layout>
    );
  }
}

export default authRoute(Dashboard);



// WEBPACK FOOTER //
// ./src/Pages/Dashboard.js